export default __webpack_public_path__ + "static/media/new.931a8001.gif";